import ky from "ky";

import { BASE_URL } from "./constants/index";
import { envelopeHook } from "./hooks/envelope";
import { errorShapeHook } from "./hooks/errorShape";

// Shared base: envelope unwrap + error normalization only.
// No loader, no auth, no token refresh — safe to import from any hook file.
//
// retry: 0 — ky defaults to 2 retries (GET/PUT/HEAD/DELETE/OPTIONS/TRACE on
// 408/429/5xx) with exponential backoff. The previous HTTP layer (axios) had
// zero automatic retries; all retries were intentional application-level logic.
// Setting retry: 0 restores parity with that behavior. Application-level
// retries (token refresh on 403) are handled explicitly by afterResponse hooks.
export const base = ky.create({
  hooks: {
    afterResponse: [envelopeHook],
    beforeError: [errorShapeHook],
  },
  prefix: BASE_URL,
  retry: 0,
  throwHttpErrors: true,
});
